import { AxiosResponse } from 'axios';
import { euSignSettingsService } from '@/services/eusign-settings.service';
import { appSettingsHelper } from '@/helpers/settings-helper';
import { logger } from '@/helpers/log.service';

let certifyingAuthorities: Array<any> | null = null;
let caCertificates: Uint8Array | null = null;

class EuSignFilesService {
  private loadCasJsonPromise: Promise<AxiosResponse<any, any>> | null = null;
  private loadCasCertificatesPromise: Promise<AxiosResponse<any, any>> | null = null;

  public async getCertifyingAuthorities(ignoreCache: boolean = false): Promise<Array<any> | null> {
    if (!certifyingAuthorities || ignoreCache) {
      const res = await this.getCasJson();
      certifyingAuthorities = this._updateTreasuryOcsp(res.data);
    }
    logger.debug(`[EuSignFilesService:getCertifyingAuthorities] certifyingAuthorities`, certifyingAuthorities);
    return certifyingAuthorities;
  }

  private _updateTreasuryOcsp(cas: Array<any>): Array<any> {
    let { useCZOAsMainOCSP } = appSettingsHelper.appSettings.euSign;
    logger.debug(`[EuSignFilesService:_updateTreasuryOcsp] useCZOAsMainOCSP = "${useCZOAsMainOCSP}"`);
    if (useCZOAsMainOCSP && cas && cas.length > 0) {
      let treasuryRegex = new RegExp(/казначей/gi);
      let treasuryCa = cas.find(c => c.address === 'ca.treasury.gov.ua' || (c.issuerCNs || []).some(i => treasuryRegex.test(i)));
      logger.debug(`[EuSignFilesService:_updateTreasuryOcsp] treasuryCa`, treasuryCa);
      if (treasuryCa) {
        treasuryCa.ocspAccessPointAddress = 'czo.gov.ua';
        treasuryCa.ocspAccessPointPort = '80';
      }
    }
    return cas;
  }

  private async getCasJson(): Promise<AxiosResponse<any, any>> {
    if (!this.loadCasJsonPromise) {
      this.loadCasJsonPromise = euSignSettingsService.getCasJson().finally(() => {
        this.loadCasJsonPromise = null;
      });
    }
    return this.loadCasJsonPromise;
  }

  public async getCaCertificates(ignoreCache: boolean = false): Promise<Uint8Array | null> {
    if (!caCertificates || ignoreCache) {
      const res = await this.getCasCertificates();
      const buf = await res.data.arrayBuffer();
      caCertificates = new Uint8Array(buf);
    }
    return caCertificates;
  }

  private async getCasCertificates(): Promise<AxiosResponse<any, any>> {
    if (!this.loadCasCertificatesPromise) {
      this.loadCasCertificatesPromise = euSignSettingsService.getCasCertificates().finally(() => {
        this.loadCasCertificatesPromise = null;
      });
    }
    return this.loadCasCertificatesPromise;
  }

  public clearCache(): void {
    certifyingAuthorities = null;
    caCertificates = null;
  }
}

const euSignFilesService = new EuSignFilesService();

export { euSignFilesService };
